import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import LoadingIndicator from "../../../../loading-indicator";
import TeaserNews, {
  teaserNewsPropTypes,
} from "../../../../teaser-base/news/teaser-news";
import TeaserPersonContact from "../../../../teaser-base/person/teaser-person-contact";
import { teaserPersonPropTypes } from "@default/teasers/person/teaser-person";
import { pagerFullPagesAction } from "@default/js/app-actions";
import { teaserEventPropTypes } from "@default/teasers/event/teaser-event";
import TeaserGeneral, {
  teaserGeneralPropTypes,
} from "../../../../teaser-base/general/teaser-general";
import TeaserSpeaker, {
  teaserSpeakerPropTypes,
} from "../../../../teaser-base/speaker/teaser-speaker";
import { teaserProjectPropTypes } from "@default/teasers/project/teaser-project";
import useTeaserQuery from "./use-teaser-query";
import ActsList from "../acts/acts-list";
import classNames from "classnames";

const ComponentTeaserListWrap = (props) => {
  const dispatch = useDispatch();
  const { nodes, loading } = useTeaserQuery(props.manualNodes, {
    ...props,
  });

  const pushPagerFullPageConfig = () => {
    if (props.pagerFullPage && nodes) {
      const pagerFullPagesConfig = {
        id: props.id,
        items:
          props.mode === "manual"
            ? props.manualNodes.map((item) => item.entity)
            : nodes.items,
        overviewLink: props.pagerFullPageOverviewLink,
      };

      dispatch(pagerFullPagesAction(pagerFullPagesConfig));
    }
  };

  useEffect(() => {
    pushPagerFullPageConfig();
  }, [nodes]);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (nodes.length && props.participantType !== "act") {
    return (
      <>
        {nodes.filter(Boolean).map((item, index) => (
          <>
            {item &&
              <div
                key={index}
                className={classNames({
                  "col-12": true,
                  "col-lg-6": props.type === "person"
                })}
              >
                {(() => {
                  item = item?.entity || item;
                  switch (item?.entityBundle) {
                    case "news":
                      return (
                        <TeaserNews
                          item={item}
                          pagerFullPage={props.pagerFullPage}
                        />
                      );
                    case "person":
                      return (
                        <TeaserPersonContact
                          count={props.limit}
                          item={item}
                          pagerFullPage={props.pagerFullPage}
                        />
                      );
                    case "participant":
                      return (
                        <TeaserSpeaker
                          count={props.limit}
                          item={item}
                          pagerFullPage={props.pagerFullPage}
                          updateUrl={true}
                        />
                      );
                    case "landingpage":
                      return (
                        <TeaserGeneral
                          item={item}
                          pagerFullPage={props.pagerFullPage}
                        />
                      );
                    default:
                      return null;
                  }
                })()}
              </div>
            }
          </>
        ))}
      </>
    );
  }
  if (nodes.length >= 2 && props.participantType === "act") {
    return <ActsList nodes={nodes} participantTypeFilter={props.participantType}  />;
  }
};

ComponentTeaserListWrap.propTypes = {
  limit: PropTypes.number,
  manualNodes: PropTypes.arrayOf(
    PropTypes.oneOfType([
      teaserNewsPropTypes,
      teaserEventPropTypes,
      teaserPersonPropTypes,
      teaserGeneralPropTypes,
      teaserProjectPropTypes,
      teaserSpeakerPropTypes,
    ])
  ),
  id: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(["auto", "manual"]),
  type: PropTypes.oneOf(["news", "person", "event", "all", "acts"]),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
  pagerFullPage: PropTypes.bool,
  pagerFullPageOverviewLink: PropTypes.object,
};

export default ComponentTeaserListWrap;
